<template>
  <div>
    <b-modal id="helpDeskModal" v-model="HelpDeskInformation.Show">
      <div class="text-center" style="padding:0 40px;">
        <div v-show="HelpDeskInformation.ShowInfo">
          <p
            style="text-align:center;margin-bottom:30px"
          >Seleccioná una opción para comunicarte con Mesa de Ayuda.</p>
          <!-- <p>
            <base-button
              style="width:75%;background-color:#25D366;border-color:#25D366;"
              @click="abrirWhatsapp()"
            >
              <img
                src="/img/whatsapp.png"
                height="30px"
                width="30px"
                class="imgbtn img-fluid d-none d-sm-inline"
                style="float:left;"
              />
              Whatsapp
            </base-button>
          </p> -->
          <p>
            <base-button
              style="width:75%;background-color:rgb(255,88,85);border-color:rgb(255,88,85)"
              @click="abrirEditorCorreo()"
            >
              <img
                src="/img/email.png"
                height="30px"
                width="30px"
                class="imgbtn img-fluid d-none d-sm-inline"
                style="float:left;"
              />
              Email
            </base-button>
          </p>
          <p>
            <b-button

              @click="HelpDeskInformation.ShowInfo=false"
              style="border-color:#f5365c;color:#f5365c;font-weight:100;width:75%"
            >Volver</b-button>
          </p>
        </div>
        <div v-show="!HelpDeskInformation.ShowInfo">
          <p>
            <img src="/img/error.png" class="img-fluid" style="width:20%" />
          </p>
          <p style="text-align:center;margin-bottom:30px;">{{HelpDeskInformation.Message}}</p>
          <p>
            <base-button
              style="width:75%;"
              v-show="HelpDeskInformation.ShowUnlockMail"
              type="primary"
              @click="sendMailToRecoverPassword()"
            >Mail Desbloqueo Automático</base-button>
          </p>
          <p v-show="HelpDeskInformation.ShowContactarSoporte">
            <base-button
              style="width:75%;background-color:rgb(255,88,85);border-color:rgb(255,88,85)"
              type="primary"
              @click="HelpDeskInformation.ShowInfo=true"
            >Contactar Mesa de Ayuda</base-button>
          </p>
          <p v-show="HelpDeskInformation.ShowContactarSoporte">
            <b-button
              @click="cerrarModalHelpDesk()"
              style="border-color:#f5365c;color:#f5365c;font-weight:100;width:75%"
            >Volver</b-button>
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="col-md-12 text-center" v-show="!HelpDeskInformation.ShowContactarSoporte">
          <b-button
            @click="cerrarModalHelpDesk()"
            style="border-color:#f5365c;color:#f5365c;font-weight:100;width:75%"
          >Volver</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style>
.imgbtn {
  position: absolute;
  left: 35px;
  top: 50%;
  transform: translateY(-50%);
}
</style>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  name: "ContactHelpDesk",
  props: {
    titleModal: {
      type: String,
      default: "Error",
      description: "Título del modal"
    }
  },
  data() {
    return {
      HelpDeskInformation: {
        Message: "",
        Show: false,
        ShowInfo: false,
        WhatsappUrl: "",
        PhoneNumber: "",
        EmailAddress: "",
        EmailSubject: "",
        MessageBody: "",
        ShowUnlockMail: false,
        Name: "",
        ShowContactarSoporte: false,
        IsReprint: false
      }
    };
  },
  methods: {
    cerrarModalHelpDesk() {
      if (this.HelpDeskInformation.IsReprint) {
        this.$router.push({
          name: "MyMastercardWallet",
          params: { IsReprint: true }
        });
      } else {
        this.HelpDeskInformation.Show = false;
        this.HelpDeskInformation.ShowInfo = false;
      }
    },
    sendMailToRecoverPassword() {
      let context = this;

      axiosHelpers.axiosPost(
        "Account/CrearSolicitudCambioPassword",
        {
          Identifier: this.HelpDeskInformation.Name
        },
        this,
        function(data) {
          if (data.ResponseVM.Resultado) {
            notificationHelpers.showSuccess(
              "Mail enviado!",
              "Se ha enviado un mail a " +
                data.ResponseVM.EmailDestino +
                " con un enlace para que pueda cambiar su contraseña",
              context
            );

            context.cerrarModalHelpDesk();
          }
        }
      );
    },
    abrirWhatsapp() {
      var whatsappUrl = this.HelpDeskInformation.WhatsappUrl;
      var phoneNumber = this.HelpDeskInformation.PhoneNumber;
      var messageBody = this.HelpDeskInformation.MessageBody;
      window.open(
        whatsappUrl
          .toString()
          .replace("{0}", phoneNumber)
          .replace("{1}", messageBody),
        "_blank"
      );
    },
    abrirEditorCorreo() {
      var emailAddress = this.HelpDeskInformation.EmailAddress;
      var emailSubject = this.HelpDeskInformation.EmailSubject;
      var messageBody = this.HelpDeskInformation.MessageBody;
      window.location.href =
        "mailto:" +
        emailAddress +
        "?subject=" +
        emailSubject +
        "&body=" +
        messageBody;
    },
    setHelpDeskInformation(helpDeskInformation) {
      this.HelpDeskInformation.Message = helpDeskInformation.Message;
      this.HelpDeskInformation.Show = helpDeskInformation.Show;
      this.HelpDeskInformation.WhatsappUrl = helpDeskInformation.UrlWhatsapp;
      this.HelpDeskInformation.PhoneNumber = helpDeskInformation.PhoneNumber;
      this.HelpDeskInformation.EmailAddress = helpDeskInformation.EmailAddress;
      this.HelpDeskInformation.EmailSubject = helpDeskInformation.EmailSubject;
      this.HelpDeskInformation.MessageBody = helpDeskInformation.MessageBody;
      this.HelpDeskInformation.ShowUnlockMail =
        helpDeskInformation.ShowUnlockMail;
      this.HelpDeskInformation.Name = helpDeskInformation.Name;
      this.HelpDeskInformation.ShowContactarSoporte =
        helpDeskInformation.ShowContactarSoporte;
      this.HelpDeskInformation.IsReprint = helpDeskInformation.IsReprint;
    }
  }
};
</script>